import src from "./andre-drummond-hero-with-case-mobile.jpg";
export default { src: src, aspect: 0.6136, width: 1248, height: 2034 };